export function getQuickEditUnits(item) {
  return [...(item.product_units || [])]
    .filter((unit) => unit.is_active !== false)
    .sort(
      (left, right) =>
        Number(left.display_order || 0) - Number(right.display_order || 0) ||
        Number(left.id || 0) - Number(right.id || 0),
    );
}

export function buildQuickEditUnitsForSave(units, parentPrice) {
  return (units || []).map((unit) => ({
    ...unit,
    selling_price: unit.is_base_unit
      ? Number(parentPrice)
      : Number(unit.selling_price),
  }));
}
